var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{on:{"click":function($event){_vm.props.callback(_vm.props.parameters.fName, _vm.props.parameters.row).click(_vm.props.parameters.fName, _vm.props.parameters.row)}}},[_vm._v(" "+_vm._s(_vm.props.callback(_vm.props.parameters.fName, _vm.props.parameters.row).text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }